import Axios from "axios";
import { getEnvVar } from "ideas.env";
import { getRequestHeaders } from "utils/getRequestHeaders";

export type TourDjango = {
  id: string;
  tour_id: string;
  completed: boolean;
  dismissed: boolean;
  user: string;
  project?: string;
  project_tour_type: number;
};

export const getUserToursDjango = async () => {
  const url = getEnvVar("URL_TENANT_USER_TOUR");
  const headers = await getRequestHeaders();
  const { data } = await Axios.get<TourDjango[]>(url, { headers });
  return data;
};

export const createOrUpdateUserTourDjango = async (
  tourKey: string,
  completed: boolean,
  dismissed = false,
  tourId?: string,
) => {
  const url = getEnvVar("URL_TENANT_USER_TOUR");
  const headers = await getRequestHeaders();
  if (tourId !== undefined) {
    try {
      const { data, error } = await updateUserTourDjango(
        tourId,
        completed,
        dismissed,
      );
      return { data: data, error: error };
    } catch (error) {
      return { data: undefined, error: new Error("Failed to update tour") };
    }
  } else {
    try {
      const { data } = await Axios.post<TourDjango>(
        url,
        {
          tour_id: tourKey,
          completed,
          dismissed,
        },
        { headers },
      );
      return { data, error: undefined };
    } catch (error) {
      return { data: undefined, error: new Error("Failed to create tour") };
    }
  }
};

export const updateUserTourDjango = async (
  tourId: string,
  completed: boolean,
  dismissed = false,
) => {
  const url = getEnvVar("URL_TENANT_USER_TOUR");
  const headers = await getRequestHeaders();
  try {
    const { data } = await Axios.patch<TourDjango>(
      `${url}${tourId}/`,
      {
        tour_id: tourId,
        completed,
        dismissed,
      },
      { headers },
    );
    return { data: data, error: undefined };
  } catch (error) {
    return { data: undefined, error: new Error("Failed to update tour") };
  }
};
